import React from "react";
import css from "./PanelBody.module.css";

import cn from "classnames";

type Props = {
    className?: string;
    marginTop?: "40px" | "12px";
};

export const PanelBody: React.FC<React.PropsWithChildren<Props>> = ({
    className,
    children,
    marginTop = "40px",
}) => {
    return (
        <div className={cn(css.main, className)} style={{ marginTop }}>
            {children}
        </div>
    );
};
